import React, { useEffect, useState } from "react";
import { BrowserRouter, Route, Navigate, Routes } from "react-router-dom";
import { Provider } from "react-redux";
import { Provider as ReduxQueryProvider } from "redux-query-react";
import store from "./reducers/store";
import "react-toastify/dist/ReactToastify.css";
import { Main } from "./components/Main";
import ScrollToTop from "./components/ScrollToTop";
import Disclaimer from "./components/Disclaimer";
import disclaimerConfig from "./config/disclaimerConfig";

const Router = () => {
  const [disclaimerAccepted, setDisclaimerAccepted] = useState(false);

  useEffect(() => {
    try {
      const hasAccepted = sessionStorage.getItem(disclaimerConfig.storageKey);
      setDisclaimerAccepted(hasAccepted === "true");
    } catch (error) {
      console.error("Failed to read disclaimer acceptance:", error);
      setDisclaimerAccepted(false);
    }
  }, []);

  const handleDisclaimerAccept = () => {
    try {
      sessionStorage.setItem(disclaimerConfig.storageKey, "true");
      setDisclaimerAccepted(true);
    } catch (error) {
      console.error(
        "Failed to save disclaimer acceptance to sessionStorage:",
        error,
      );
      setDisclaimerAccepted(true);
    }
  };

  return (
    <BrowserRouter basename={"/"}>
      <ScrollToTop>
        <Routes>
          {/* Main application routes */}
          <Route path="/app/*" element={<Main />} />
          {/* Catch-all redirect */}
          <Route path="*" element={<Navigate to="/app" replace />} />
        </Routes>
      </ScrollToTop>
      {!disclaimerAccepted && <Disclaimer onAccept={handleDisclaimerAccept} />}
    </BrowserRouter>
  );
};

const App = () => (
  <Provider store={store}>
    <ReduxQueryProvider queriesSelector={(state) => state.queries}>
      <Router />
    </ReduxQueryProvider>
  </Provider>
);

export default App;
